import { useAccountStorage } from '../../../../../AppClients';
import { FullPageWizard } from '../../../../../ui/components/deprecated/FullPageWizard';
import { AccountSectionComponent, useAccountSections } from '../../../../../ui/features/accounts';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { ContactManagementConfigContext } from '../../../../../ui/providers';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useUserClient } from '@juvare/platform-sdk-react/ui/hooks';
import { platformSlice } from '@juvare/platform-sdk-react/ui/stores';
import { Box } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
export const LoginCompletionWizard = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const { appContext } = React.useContext(ContactManagementConfigContext);
    const { initState, userState, invalidateState } = React.useContext(appContext);
    const navigationContext = React.useContext(NavigationContext);
    const userClient = useUserClient();
    const storageClient = useAccountStorage();
    const dispatch = useDispatch();
    const incompleteSectionIds = userState ? userState.loginValidationResult.incompleteSections.map((section) => section.id) : [];
    const [account, setAccount] = React.useState();
    const [changed, setChanged] = React.useState(false);
    const steps = ((_a = useAccountSections('login-completion').data) !== null && _a !== void 0 ? _a : [])
        .filter((section) => incompleteSectionIds.includes(section.id))
        .map((section) => ({
        label: section.columns.title,
        render: (props) => React.createElement(AccountSectionComponent, Object.assign({ section: section, page: 'login-completion', accountId: account === null || account === void 0 ? void 0 : account.id }, props)),
    }));
    React.useEffect(() => {
        if (userState) {
            storageClient.get(userState.id).then(setAccount).catch(handleErrorDialog);
        }
    }, [storageClient, userState]);
    const handleChanged = React.useCallback((changed) => {
        if (changed) {
            navigationContext.setChanged(t('common.confirmWizardClose'));
        }
        else {
            navigationContext.clearChanged();
        }
        setChanged(changed);
    }, [t, navigationContext]);
    if (account && steps.length > 0) {
        return (React.createElement(Box, { sx: { p: 2, height: '100%', backgroundColor: (theme) => theme.palette.background.paper } },
            React.createElement(FullPageWizard, { steps: steps, data: account.data, backButtonTitle: t('common.logOut'), onBack: () => {
                    const logOut = () => {
                        navigationContext.clearChanged();
                        userClient
                            .logout()
                            .then(() => initState())
                            .catch(() => initState());
                    };
                    if (changed) {
                        showConfirmDialog({
                            title: t('common.confirmWizardClose'),
                            confirmLabel: t('common.closeWizardWithoutSaving'),
                            onConfirm: logOut,
                        });
                    }
                    else {
                        logOut();
                    }
                }, onChanged: handleChanged, onSubmit: (data) => {
                    const savePromise = storageClient.post({
                        action: 'partial-update',
                        id: account.id,
                        data: data,
                    });
                    navigationContext.save(savePromise);
                    return savePromise;
                }, onSubmitSuccess: () => {
                    invalidateState().catch(handleErrorSnackbar);
                    userClient.getUserState().then((response) => dispatch(platformSlice.actions.setUser(response)));
                } })));
    }
    else {
        return React.createElement(React.Fragment, null, props.children);
    }
};
